import React, { Requireable } from 'react';
import * as ReactDOM from 'react-dom/client';
import PropTypes from 'prop-types';
import reactToWebComponent from 'react-to-webcomponent';
import App from './App';
import ComposerPage from './pages/ComposerPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import HomePage from './pages/HomePage';
import OfferPage from './pages/OfferPage';
import SubscriptionsPage from './pages/SubscriptionsPage';
import ImplementationPage from './pages/ImplementationPage';
import CheckoutPage from './pages/CheckoutPage';
import StandardTemplatesPage from './pages/StandardTemplatesPage';
import CrossborderPage from './pages/CrossborderPage';
import WealthonPage from './pages/WealthonPage';
import ContractPage from './pages/ContractPage';
import ContractsPage from './pages/ContractsPage';
import EmagPage from './pages/EmagPage';
import PosPage from './pages/PosPage';
import PosPageEn from './pages/PosPageEn';
import PackagesPage from './pages/PackagesPage';
import AppsPage from './pages/AppsPage';
import MultichannelPage from './pages/MultichannelPage';
import ReturnPage from './pages/ReturnPage';
import ABTestsPage from './pages/ABTests';
import RWDPage from './pages/RWDPage';
import SubscriptionModulePage from './pages/SubscriptionModulePage';
import GoogleAnalyticsPage from './pages/GoogleAnalyticsPage';
import RsPage from './pages/RsPage';
import SocialMediaPageComponent from './pages/SocialMedia';
import ERPPageComponent from './pages/ERPPage';
import AffiliatePageComponent from './pages/AffiliatePage';
import PaymentsPage from './pages/PaymentsPage';
import MarketplacePage from './pages/MarketplacePage';
import BrokerPage from './pages/BrokerPage/index';
import InpostPage from './pages/InpostPage';
import OpinionsPage from './pages/OpinionsPage';
import FulfillmentPage from './pages/FulfillmentPage';
import MarketingAutomationComponent from './pages/MarketingAutomation';

/*
<link rel="stylesheet" href="https://idosell-pages.vercel.app/static/css/main.css">
 <script defer="defer" src="https://idosell-pages.vercel.app/static/js/main.js"></script>
 */

// How to use:
// <script defer="defer" src="https://idosell-pages.vercel.app/static/js/main.js"></script>
// <r2wc-checklist items='[{"label":"First Thing","isChecked":false}]' />

//ComposerPAGE
class WebComponentWrapperComposer extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return <ComposerPage />;
    }
}
const composerPage = reactToWebComponent(WebComponentWrapperComposer, React, ReactDOM, {
    dashStyleAttributes: true,
});
const composerPageShadow = reactToWebComponent(WebComponentWrapperComposer, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: false,
});
// const wcChecklistShadow = reactToWebComponent(WebComponentWrapper, { shadow: "open" });

customElements.define('r2wc-composer-page', composerPage);
customElements.define('r2wc-composer-page-shadow', composerPageShadow);

// How to use:
// <r2wc-composer-page  />

//Case Studies Page
class WebComponentWrapperCaseStudies extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return <CaseStudiesPage />;
    }
}

const caseStudiesPage = reactToWebComponent(WebComponentWrapperCaseStudies, React, ReactDOM, {
    dashStyleAttributes: true,
});
const caseStudiesPageShadow = reactToWebComponent(WebComponentWrapperCaseStudies, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: false,
});
// const wcChecklistShadow = reactToWebComponent(WebComponentWrapper, { shadow: "open" });

customElements.define('r2wc-case-studies-page', caseStudiesPage);
customElements.define('r2wc-case-studies-page-shadow', caseStudiesPageShadow);

class WebComponentWrapperHomePage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <HomePage />
            </App>
        );
    }
}

const homePage = reactToWebComponent(WebComponentWrapperHomePage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const homePageShadow = reactToWebComponent(WebComponentWrapperHomePage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});
// const wcChecklistShadow = reactToWebComponent(WebComponentWrapper, { shadow: "open" });

customElements.define('homepage-page', homePage);
customElements.define('homepage--shadow', homePageShadow);
// How to use:
// <r2wc-idopay-page  />

class WebComponentWrapperOfferPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <OfferPage />
            </App>
        );
    }
}

const offerPage = reactToWebComponent(WebComponentWrapperOfferPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const offerPageShadow = reactToWebComponent(WebComponentWrapperOfferPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});
// const wcChecklistShadow = reactToWebComponent(WebComponentWrapper, { shadow: "open" });

customElements.define('offerpage-page', offerPage);
customElements.define('offerpage--shadow', offerPageShadow);

class WebComponentWrapperSubscriptionsPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <SubscriptionsPage />
            </App>
        );
    }
}

const subscriptionsPage = reactToWebComponent(
    WebComponentWrapperSubscriptionsPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: true,
    },
);
const subscriptionsPageShadow = reactToWebComponent(
    WebComponentWrapperSubscriptionsPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: false,
        shadow: true,
    },
);

customElements.define('subscriptionspage-page', subscriptionsPage);
customElements.define('subscriptionspage--shadow', subscriptionsPageShadow);

class WebComponentWrapperImplementationPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <ImplementationPage />
            </App>
        );
    }
}

const implementationPage = reactToWebComponent(
    WebComponentWrapperImplementationPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: true,
    },
);
const implementationPageShadow = reactToWebComponent(
    WebComponentWrapperImplementationPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: false,
        shadow: true,
    },
);

customElements.define('implementation-page', implementationPage);
customElements.define('implementationpage--shadow', implementationPageShadow);

class WebComponentWrapperCheckoutPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <CheckoutPage />
            </App>
        );
    }
}

const CheckoutWebPage = reactToWebComponent(WebComponentWrapperCheckoutPage, React, ReactDOM, {
    dashStyleAttributes: true,
});

const CheckoutPageShadow = reactToWebComponent(
    WebComponentWrapperImplementationPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: false,
        shadow: true,
    },
);

customElements.define('checkout-page', CheckoutWebPage);
customElements.define('checkoutpage--shadow', CheckoutPageShadow);

class WebComponentWrapperStandardTemplatesPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <StandardTemplatesPage />
            </App>
        );
    }
}

const standardTemplatesPage = reactToWebComponent(
    WebComponentWrapperStandardTemplatesPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: true,
    },
);

const StandardTemplatesPagehadow = reactToWebComponent(
    WebComponentWrapperImplementationPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: false,
        shadow: true,
    },
);

customElements.define('standardtemplates-page', standardTemplatesPage);
customElements.define('standardtemplatespage--shadow', StandardTemplatesPagehadow);

class WebComponentWrapperCrossborderPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <CrossborderPage />
            </App>
        );
    }
}

const CrossborderPageNormal = reactToWebComponent(
    WebComponentWrapperCrossborderPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: true,
    },
);

const CrossborderPageShadow = reactToWebComponent(
    WebComponentWrapperCrossborderPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: false,
        shadow: true,
    },
);

customElements.define('crossborder-page', CrossborderPageNormal);
customElements.define('crossborderpage--shadow', CrossborderPageShadow);

//WealthonPage
class WebComponentWrapperWealthonPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <WealthonPage />
            </App>
        );
    }
}

const wealthonPage = reactToWebComponent(WebComponentWrapperWealthonPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const wealthonPageShadow = reactToWebComponent(WebComponentWrapperWealthonPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('wealthonpage-page', wealthonPage);
customElements.define('wealthonpage--shadow', wealthonPageShadow);

//ContractPage
class WebComponentWrapperContractPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <ContractPage />
            </App>
        );
    }
}

const contractPage = reactToWebComponent(WebComponentWrapperContractPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const contractPageShadow = reactToWebComponent(WebComponentWrapperContractPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('contract-page', contractPage);
customElements.define('contractpage--shadow', contractPageShadow);

//EmagPage
class WebComponentWrapperEmagPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <EmagPage />
            </App>
        );
    }
}

const emagPage = reactToWebComponent(WebComponentWrapperEmagPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const emagPageShadow = reactToWebComponent(WebComponentWrapperEmagPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('emag-page', emagPage);
customElements.define('emagpage--shadow', emagPageShadow);

//PosPagePL
class WebComponentWrapperPosPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <PosPage />
            </App>
        );
    }
}

const posPage = reactToWebComponent(WebComponentWrapperPosPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const posPageShadow = reactToWebComponent(WebComponentWrapperPosPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('pos-page', posPage);
customElements.define('pospage--shadow', posPageShadow);

//PosPageEN
class WebComponentWrapperPosPageEn extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <PosPageEn />
            </App>
        );
    }
}

const posPageEn = reactToWebComponent(WebComponentWrapperPosPageEn, React, ReactDOM, {
    dashStyleAttributes: true,
});
const posPageShadowEn = reactToWebComponent(WebComponentWrapperPosPageEn, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('pos-page-en', posPageEn);
customElements.define('pospage--shadow-en', posPageShadowEn);

//PackagesPage
class WebComponentWrapperPackagesPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <PackagesPage />
            </App>
        );
    }
}

const packagesPage = reactToWebComponent(WebComponentWrapperPackagesPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const packagesPageShadow = reactToWebComponent(WebComponentWrapperPackagesPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('packagespage-page', packagesPage);
customElements.define('packagespage-page--shadow', packagesPageShadow);

//AppsPage
class WebComponentWrapperAppsPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <AppsPage />
            </App>
        );
    }
}

const appsPage = reactToWebComponent(WebComponentWrapperAppsPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const appsPageShadow = reactToWebComponent(WebComponentWrapperAppsPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('appspage-page', appsPage);
customElements.define('appspage-page--shadow', appsPageShadow);

//ContractsPage
class WebComponentWrapperContractsPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <ContractsPage />
            </App>
        );
    }
}

const contractsPage = reactToWebComponent(WebComponentWrapperContractsPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const contractsPageShadow = reactToWebComponent(WebComponentWrapperContractsPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('contracts-page', contractsPage);
customElements.define('contractspage--shadow', contractsPageShadow);

//MultichannelPage
class WebComponentWrapperMultichannelPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <MultichannelPage />
            </App>
        );
    }
}

const multichannelPage = reactToWebComponent(WebComponentWrapperMultichannelPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const multichannelPageShadow = reactToWebComponent(
    WebComponentWrapperMultichannelPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: false,
        shadow: true,
    },
);

customElements.define('multichannel-page', multichannelPage);
customElements.define('multichannel-page--shadow', multichannelPageShadow);

//ReturnPage
class WebComponentWrapperReturnPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <ReturnPage />
            </App>
        );
    }
}

const returnPage = reactToWebComponent(WebComponentWrapperReturnPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const returnPageShadow = reactToWebComponent(WebComponentWrapperReturnPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('return-page', returnPage);
customElements.define('return-page--shadow', returnPageShadow);

//ABTestsPage
class WebComponentWrapperABTestsPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <ABTestsPage />
            </App>
        );
    }
}

const abTestPage = reactToWebComponent(WebComponentWrapperABTestsPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const abTestPageShadow = reactToWebComponent(WebComponentWrapperABTestsPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('ab-test-page', abTestPage);
customElements.define('ab-test-page--shadow', abTestPageShadow);

//RWDPage
class WebComponentWrapperRWDPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <RWDPage />
            </App>
        );
    }
}

const rwdPage = reactToWebComponent(WebComponentWrapperRWDPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const rwdPageShadow = reactToWebComponent(WebComponentWrapperRWDPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('rwd-page', rwdPage);
customElements.define('rwd-page--shadow', rwdPageShadow);

// SubscriptionModulePage
class WebComponentWrapperSubscriptionPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <SubscriptionModulePage />
            </App>
        );
    }
}

const subscriptionModulePage = reactToWebComponent(
    WebComponentWrapperSubscriptionPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: true,
    },
);
const subscriptionModulePageShadow = reactToWebComponent(
    WebComponentWrapperSubscriptionPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: false,
        shadow: true,
    },
);

customElements.define('subscription-module', subscriptionModulePage);
customElements.define('subscription-module--shadow', subscriptionModulePageShadow);

// RsPage
class WebComponentWrapperRsPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <RsPage />
            </App>
        );
    }
}

const RsPageModule = reactToWebComponent(WebComponentWrapperRsPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const RsPageShadow = reactToWebComponent(WebComponentWrapperRsPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('rs-page', RsPageModule);
customElements.define('rs-page--shadow', RsPageShadow);

// SocialMediaPage
class WebComponentWrapperSocialMediaPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <SocialMediaPageComponent />
            </App>
        );
    }
}

const SocialMediaPage = reactToWebComponent(WebComponentWrapperSocialMediaPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const SocialMediaPageShadow = reactToWebComponent(
    WebComponentWrapperSocialMediaPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: false,
        shadow: true,
    },
);

customElements.define('social-media-page', SocialMediaPage);
customElements.define('social-media-page--shadow', SocialMediaPageShadow);

// ERPPage
class WebComponentWrapperERPPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <ERPPageComponent />
            </App>
        );
    }
}

const ERPPage = reactToWebComponent(WebComponentWrapperERPPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const ERPPageShadow = reactToWebComponent(WebComponentWrapperERPPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('erp-page', ERPPage);
customElements.define('erp-page--shadow', ERPPageShadow);

// SubscriptionModulePage
class WebComponentWrapperGoogleAnalyticsPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <GoogleAnalyticsPage />
            </App>
        );
    }
}

const googleAnalyticsPage = reactToWebComponent(
    WebComponentWrapperGoogleAnalyticsPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: true,
    },
);
const googleAnalyticsPageShadow = reactToWebComponent(
    WebComponentWrapperGoogleAnalyticsPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: false,
        shadow: true,
    },
);

customElements.define('google-analytics-page', googleAnalyticsPage);
customElements.define('google-analytics-page--shadow', googleAnalyticsPageShadow);

// AffiliatePage
class WebComponentWrapperAffiliatePage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <AffiliatePageComponent />
            </App>
        );
    }
}

const AffiliatePage = reactToWebComponent(WebComponentWrapperAffiliatePage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const AffiliatePageShadow = reactToWebComponent(WebComponentWrapperAffiliatePage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('affiliate-page', AffiliatePage);
customElements.define('affiliate-page--shadow', AffiliatePageShadow);

// Payments Page
class WebComponentWrapperPaymentsPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <PaymentsPage />
            </App>
        );
    }
}

const paymentsPage = reactToWebComponent(WebComponentWrapperPaymentsPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const paymentsPageShadow = reactToWebComponent(WebComponentWrapperPaymentsPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('payments-page', paymentsPage);
customElements.define('payments-page--shadow', paymentsPageShadow);

// Marketplace Page
class WebComponentWrapperMarketplacePage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <MarketplacePage />
            </App>
        );
    }
}

const marketplacePage = reactToWebComponent(WebComponentWrapperMarketplacePage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const marketplacePageShadow = reactToWebComponent(
    WebComponentWrapperMarketplacePage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: false,
        shadow: true,
    },
);

customElements.define('marketplace-page', marketplacePage);
customElements.define('marketplace-page--shadow', marketplacePageShadow);

// BrokerPage

class WebComponentWrapperBrokerPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <BrokerPage />
            </App>
        );
    }
}

const brokerPage = reactToWebComponent(WebComponentWrapperBrokerPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const brokerPageShadow = reactToWebComponent(WebComponentWrapperBrokerPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('broker-page', brokerPage);
customElements.define('broker-page--shadow', brokerPageShadow);

// InpostPage
class WebComponentWrapperInpostPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <InpostPage />
            </App>
        );
    }
}

const inpostPage = reactToWebComponent(WebComponentWrapperInpostPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const inpostPageShadow = reactToWebComponent(WebComponentWrapperInpostPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('inpost-page', inpostPage);
customElements.define('inpost-page--shadow', inpostPageShadow);

// OpinionsPage
class WebComponentWrapperOpinionsPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <OpinionsPage />
            </App>
        );
    }
}

const opinionsPage = reactToWebComponent(WebComponentWrapperOpinionsPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const opinionsPageShadow = reactToWebComponent(WebComponentWrapperOpinionsPage, React, ReactDOM, {
    dashStyleAttributes: false,
    shadow: true,
});

customElements.define('opinions-page', opinionsPage);
customElements.define('opinions-page--shadow', opinionsPageShadow);

// FulfillmentModulePage
class WebComponentWrapperFulfillmentPage extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <FulfillmentPage />
            </App>
        );
    }
}

const fulfillmentPage = reactToWebComponent(WebComponentWrapperFulfillmentPage, React, ReactDOM, {
    dashStyleAttributes: true,
});
const fulfillmentPageShadow = reactToWebComponent(
    WebComponentWrapperFulfillmentPage,
    React,
    ReactDOM,
    {
        dashStyleAttributes: false,
        shadow: true,
    },
);

customElements.define('fulfillment-page', fulfillmentPage);
customElements.define('fulfillment-page--shadow', fulfillmentPageShadow);

// MarketingAutomation
class WebComponentWrapperMarketingAutomation extends React.Component<{}, {}> {
    static propTypes: {};
    render() {
        return (
            <App>
                <MarketingAutomationComponent />
            </App>
        );
    }
}

const marketingAutomationPage = reactToWebComponent(
    WebComponentWrapperMarketingAutomation,
    React,
    ReactDOM,
    {
        dashStyleAttributes: true,
    },
);
const marketingAutomationPageShadow = reactToWebComponent(
    WebComponentWrapperMarketingAutomation,
    React,
    ReactDOM,
    {
        dashStyleAttributes: false,
        shadow: true,
    },
);

customElements.define('marketing-automation-page', marketingAutomationPage);
customElements.define('marketing-automation-page--shadow', marketingAutomationPageShadow);
